// src/utils/axios.ts
import axios from 'axios';
import { BACKEND_URL } from 'config';

export const client = axios.create({
	baseURL: BACKEND_URL,
	timeout: 5000,
	headers: {
		'Content-Type': 'application/json',
	},
});
